import { useAppSelector } from 'app-redux/hooks'
import { useRightPanel } from 'hooks/usePinnedSidecar'

import StackLayout from 'components/deckPage/DeckContainerV2/layouts/Stack'
import ManualStackLayout from 'components/deckPage/DeckContainerV2/layouts/ManualStack'
import TableLayout from 'components/deckPage/DeckContainerV2/layouts/Table'
import TextLayout from 'components/deckPage/DeckContainerV2/layouts/Text'
import GridLayout from 'components/deckPage/DeckContainerV2/layouts/Grid'
import ListLayout from 'components/deckPage/DeckContainerV2/layouts/List'
import PinnedCategory from 'components/deckPage/DeckContainerV2/cardGroups/PinnedCategory'

import { STACK, VIEW } from 'types/deck'

import styles from './deckContainerV2.module.scss'

type Props = {}

const DeckContainerV2 = ({}: Props) => {
  const view = useAppSelector(state => state.deck.view)
  const pinnedCategory = useAppSelector(state => state.cacheables.pinnedCategory)
  const draggableStacks = useAppSelector(state => state.cacheables.draggableStacks)
  const stack = useAppSelector(state => state.deck.stack)
  const disableMargins = useAppSelector(state => state.cacheables.disableMargins)

  const [rightPanelStatus] = useRightPanel()

  let layout = <StackLayout />

  // prettier-ignore
  if (draggableStacks && (stack === STACK.MULTIPLE || stack === STACK.CUSTOM) && [VIEW.CARD, VIEW.TEXT].includes(view)) layout = <ManualStackLayout />
  else if (view === VIEW.CARD) layout = <StackLayout />
  else if (view === VIEW.TEXT) layout = <TextLayout />
  else if (view === VIEW.SPREADSHEET) layout = <TableLayout />
  else if (view === VIEW.GRID) layout = <GridLayout />
  else if (view === VIEW.LIST) layout = <ListLayout />

  return (
    <div
      id="deck-container"
      className={`
        ${styles.container}
        ${disableMargins ? styles.disableMargins : ''}
        ${rightPanelStatus.locked ? styles.adjustForRightLockedPanel : ''}
      `}>
      {pinnedCategory && <PinnedCategory />}

      {layout}
    </div>
  )
}

export default DeckContainerV2
